"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 3a.7.7 0 0 1 .633.4l1.3 2.745a.7.7 0 0 1-1.265.6L12 5.334l-1.969 4.154a.7.7 0 0 1-.54.394l-4.36.576 2.118 2.295a.7.7 0 0 1-1.028.95l-3.035-3.288a.7.7 0 0 1 .422-1.168l5.321-.703L11.367 3.4A.7.7 0 0 1 12 3Zm5.47 6.568a.7.7 0 0 1 .785-.603l2.137.283a.7.7 0 0 1 .422 1.168l-3.808 4.125 1.05 5.63a.7.7 0 0 1-1.002.754L12 18.384 8.288 20.25A.7.7 0 0 1 7.66 19l4.026-2.025a.7.7 0 0 1 .63 0l4.106 2.065-.856-4.588a.7.7 0 0 1 .174-.603l3.13-3.39-.798-.106a.7.7 0 0 1-.602-.785Zm3.025-6.063a.7.7 0 0 1 0 .99l-16 16a.7.7 0 0 1-.99-.99l16-16a.7.7 0 0 1 .99 0Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=NoStarIcon24.js.map